import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/eventDiscountPurchase'
export const namespace = 'eventDiscountPurchase'
export const clientRoute = '/purchase/event-discount'
export const dependencies = ['eventDiscount', 'purchase']
export const params = {
  include: 'eventDiscount,purchase'
}
/* --------------------------- */

// /* -------- LABELS ----------- */
// const titleColumn = 'eventDiscount'
// const subtitleColumn = undefined
// const infoColumns = []
// /* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
